import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { birthdateValidator } from 'src/app/shared/custom-validators/birth-date-validator';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { Masks, MaskService } from 'src/app/shared/services/mask.service';

@Component({
  selector: 'app-birth-date-modal',
  templateUrl: './birth-date-modal.component.html',
  styleUrls: ['./birth-date-modal.component.css']
})
export class BirthDateModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<BirthDateModalComponent>,
    private maskService: MaskService,
    private formBuilder: FormBuilder,
    private alertService: AlertService) { this.matDialogRef.disableClose = true; }

  masks: Masks = this.maskService.getMasks();
  model: FormGroup;
  colorCode: string = this.data.colorCode;

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      birthDate: [Date, [Validators.required, birthdateValidator()]]
    });
  }

  submit() {
    if (this.model.invalid) {
      this.alertService.show('Erro', "Data de nascimento inválida.", AlertType.error);
      return;
    }
    this.matDialogRef.close({ birthDate: this.maskService.formatStringToDate(this.model.get('birthDate').value) });
  }
}
